/** Live-chat routing (M29 Phase 2): presence, limitasyon ng chat, mga alok at ang pila. Shell created by WP-M29-SCHEMA2: later work packages add keys inside their group (en and fil together, no dots inside key segments). */
export const routingLive = {
  presence: {
    trigger: "Status ng chat: {{status}}, {{count}} sa {{limit}} na chat",
    menu: "Ang iyong status sa chat",
    online: "Online",
    away: "Wala sa puwesto",
    busy: "Abala",
    offline: "Offline",
    autoAway: "Wala sa puwesto (walang aktibidad)",
    hintOnline: "Ihahandog sa iyo ang mga bagong chat.",
    hintAway: "Walang bagong chat. Mananatili sa iyo ang hawak mo na.",
    hintBusy: "Walang bagong chat habang tinatapos mo ang hawak mo.",
    hintOffline: "Hindi ka available para sa mga chat.",
    chats: "Chat {{count}} / {{limit}}",
    atLimit: "Abot mo na ang limitasyon sa chat",
    autoAwayNotice: "Inilagay ka sa Wala sa puwesto matapos ang ilang minutong walang aktibidad. Ibabalik ka sa Online ng anumang galaw.",
    changed: "Ikaw ay {{status}}",
    changeFailed: "Hindi mabago ang status mo. Subukan muli.",
    loadFailed: "Hindi makuha ang status mo sa chat. Subukan muli.",
    loading: "Kinukuha ang status mo sa chat",
  },
  limits: {
    title: "Limitasyon sa chat",
    intro: "Ilang chat ang puwedeng hawakan nang sabay ng bawat tao at team. Lalaktawan ang hindi online o abot na ang limitasyon kapag nag-aassign ng chat.",
    agentsTitle: "Mga agent at limitasyon",
    agentColumn: "Agent",
    statusColumn: "Status",
    teamsColumn: "Mga team",
    chatsColumn: "Mga chat",
    limitColumn: "Limitasyon",
    memberLimit: "Limitasyon sa chat ni {{name}}",
    noTeams: "Walang team",
    lowered: "Ibinaba sa {{limit}} ng limitasyon ng team",
    teamsTitle: "Limitasyon ng team",
    teamsIntro: "Binababa ng limitasyon ng team ang limitasyon ng bawat miyembro nito. Iwanang walang laman para gamitin ang sarili nilang limitasyon.",
    teamLimit: "Limitasyon sa chat ng {{name}}",
    teamPlaceholder: "Walang limitasyon",
    save: "I-save ang mga limitasyon",
    reset: "Itapon ang mga pagbabago",
    saved: "Na-save ang mga limitasyon sa chat",
    saveFailed: "Hindi ma-save ang mga limitasyon sa chat.",
    invalid: "Maglagay ng buong bilang mula {{min}} hanggang {{max}}.",
    emptyTitle: "Wala pang makakakuha ng chat",
    emptyBody: "Bigyan ang kasamahan ng role na may karapatang sumagot sa inbox at lalabas siya rito.",
    loadFailed: "Hindi ma-load ang mga limitasyon sa chat.",
    retry: "Subukan muli",
    readOnly: "Makikita mo ang mga limitasyon. Kailangan ng pahintulot na mamahala ng live chat para baguhin ang mga ito.",
    loading: "Kinukuha ang mga limitasyon sa chat",
  },
  offers: {
    region: "Mga alok na chat",
    title: "May naghihintay na chat para sa iyo",
    team: "Team {{team}}",
    attempt: "Alok {{n}}",
    accept: "Tanggapin",
    decline: "Ipasa",
    secondsLeft: "{{seconds}} s na lang",
    announce: "May inaalok na chat sa iyo. Tanggapin sa loob ng {{seconds}} segundo.",
    shortcuts: "Tanggapin {{accept}}, ipasa {{decline}}",
    taken: "Kinuha mo ang chat.",
    passed: "Ipinasa mo ang chat. Mapupunta ito sa susunod na ahente.",
    gone: "Hindi na inaalok sa iyo ang chat na iyon.",
    atLimit: "Abot mo na ang limitasyon mo sa chat. Tapusin muna ang isang chat, saka subukan ulit.",
    answerFailed: "Hindi nasagot ang alok. Subukan ulit.",
    settingsTitle: "Mga alok na chat",
    settingsIntro: "Alukin muna ang bawat naghihintay na chat sa isang ahente. Kapag hindi niya ito tinanggap sa loob ng itinakda mong oras, mapupunta ito sa susunod na ahenteng puwedeng kumuha.",
    switchLabel: "Alukin muna ang bawat chat sa isang ahente",
    switchHint: "Naka-off: direktang itatalaga ang chat sa susunod na available na ahente.",
    timeoutLabel: "Segundo para tanggapin",
    timeoutHint: "Mula {{min}} hanggang {{max}} segundo. Ang default ay {{default}}.",
    summary: "Tanggapin sa loob ng {{seconds}} s, kung hindi, susunod na ahente",
    summaryOff: "Direktang itinatalaga ang mga chat sa susunod na available na ahente",
    neverOver: "Inaalok lang ang chat sa ahenteng online at hindi lampas sa limitasyon niya sa chat. Hindi na aalukin ulit ng parehong chat ang nagpasa o hindi sumagot.",
    invalid: "Maglagay ng buong bilang mula {{min}} hanggang {{max}}.",
    save: "I-save ang mga setting ng alok",
    reset: "Itapon ang mga pagbabago",
    saved: "Na-save ang mga setting ng alok",
    saveFailed: "Hindi na-save ang mga setting ng alok.",
    loadFailed: "Hindi ma-load ang mga setting ng alok.",
    retry: "Subukan ulit",
    readOnly: "Puwede mong tingnan ang mga setting ng alok. Kailangan ng pahintulot sa live chat para baguhin ang mga ito.",
    loading: "Nilo-load ang mga setting ng alok",
  },
  queue: {
    pageTitle: "Routing ng live chat",
    pageIntro: "Sino ang unang sasagot sa naghihintay na chat, at gaano ito katagal puwedeng maghintay. Para ito sa mga chat na naghihintay ng tao.",
    reset: "Itapon ang mga pagbabago",
    retry: "Subukan ulit",
    loading: "Naglo-load",
    readOnly: "Puwede mong tingnan ang mga setting na ito. Kailangan ng pahintulot sa live chat para baguhin ang mga ito.",
    tiers: {
      title: "Mga tier at paghihintay",
      intro: "Ang puntos ng naghihintay na chat ay ang bigat ng tier nito dagdag ang mga puntos ng aging sa bawat minutong paghihintay. Ang pinakamataas na puntos ang unang sasagutin, kaya walang naghihintay nang walang katapusan.",
      tierColumn: "Tier",
      weightColumn: "Bigat",
      weightLabel: "Bigat para sa {{tier}}",
      noTier: "Lahat ng iba",
      addLabel: "Magdagdag ng tier",
      addPlaceholder: "code ng tier, hal. gold",
      addButton: "Idagdag ang tier",
      agingLabel: "Mga puntos ng aging bawat minuto ng paghihintay",
      agingHint: "Mula 0 hanggang {{max}}. Kapag 0, laging mauuna ang mas mataas na tier.",
      invalidAging: "Maglagay ng numero mula 0 hanggang {{max}} na may hanggang dalawang decimal.",
      invalidWeight: "Maglagay ng buong numero mula {{min}} hanggang {{max}}.",
      overtake: "Ang chat na walang tier ay mauuna sa bagong chat ng {{high}} kapag naghintay na ito ng {{minutes}} min.",
      overtakeNever: "Kapag walang aging, ang chat ng mas mababang tier ay puwedeng maghintay nang walang katapusan sa likod ng mas mataas.",
      noWeights: "Bigyan ng bigat ang isang tier para makita kung gaano katagal bago ito maunahan ng ibang chat.",
      safety: "Ang mga chat mula sa kinakailangang handover (gaya ng responsible gaming) ay laging mauuna sa lahat ng tier, anuman ang bigat.",
      save: "I-save ang mga tier",
      saved: "Na-save ang bigat ng mga tier",
      saveFailed: "Hindi ma-save ang bigat ng mga tier.",
    },
    ladder: {
      title: "Sino ang makakakuha, ayon sa pagkakasunod",
      intro: "Para sa mga customer na may bigat ang tier o segment. Agad lalaktawan ang hakbang na walang makakakuha.",
      rungHost: "Ang nakatalagang host nila",
      rungHostHint: "Sa loob ng {{seconds}} s, kung online at hindi pa lampas sa limitasyon ng chat",
      rungTeam: "Ang team na pinag-rutahan ng chat",
      rungTeamHint: "Pagkatapos ng {{seconds}} s",
      rungGeneral: "Lahat ng puwedeng sumagot",
      rungGeneralHint: "Pagkatapos ng {{seconds}} s, nasa unahan ng pila",
      hostLabel: "Segundong unang hawak ng host",
      teamLabel: "Segundong sunod na hawak ng team",
      invalidSeconds: "Maglagay ng buong numero mula {{min}} hanggang {{max}}.",
      hostSource: "Ang host ay nakasaad sa attribute na dedicated_host ng customer (e-mail o miyembro), na ipinapadala ng inyong sistema kasama ng customer context.",
      never: "Hindi ito nangingibabaw sa kinakailangang handover: nananatili sa sarili nilang team ang mga chat na iyon.",
      save: "I-save ang pagkakasunod",
      saved: "Na-save ang pagkakasunod ng routing",
      saveFailed: "Hindi ma-save ang pagkakasunod ng routing.",
    },
    skills: {
      title: "Mga skill sa chat",
      intro: "Ang chat na nangangailangan ng skill (wika ng customer, pagsasanay sa responsible gaming, isang segment) ay iaalok lang sa mga may hawak nito.",
      listLabel: "Mga skill sa workspace na ito",
      listHint: "Maliliit na titik, numero at underscore, pinaghihiwalay ng kuwit. Hanggang {{max}}. Gamitin ang rg_trained para sa pagsasanay sa responsible gaming.",
      invalidList: "Gumamit ng maliliit na titik, numero at underscore (hanggang 40 bawat isa), hindi hihigit sa {{max}} skill.",
      listSave: "I-save ang listahan ng skill",
      listSaved: "Na-save ang listahan ng skill",
      membersTitle: "Sino ang may anong skill",
      memberColumn: "Ahente",
      skillsColumn: "Mga skill",
      skillsOf: "Mga skill ni {{name}}",
      membersSave: "I-save ang skill ng mga ahente",
      membersSaved: "Na-save ang skill ng mga ahente",
      saveFailed: "Hindi ma-save ang mga skill.",
      loadFailed: "Hindi ma-load ang skill ng mga ahente.",
      emptyTitle: "Wala pang nakalistang skill",
      emptyBody: "Magdagdag ng skill sa itaas, saka markahan kung sinong ahente ang may hawak.",
    },
    rules: {
      title: "Mga patakaran ng segment",
      intro: "Ang mga customer sa isang segment ay nakakakuha ng dagdag na puntos bukod sa tier nila, at puwedeng mangailangan ng skill ang chat. Ginagawa ang mga segment sa Contacts.",
      segmentColumn: "Segment",
      bonusColumn: "Dagdag na puntos",
      skillColumn: "Kailangang skill",
      actionsColumn: "Mga aksyon",
      bonusLabel: "Dagdag na puntos para sa {{segment}}",
      pick: "Pumili ng segment",
      noSkill: "Walang skill",
      add: "Magdagdag ng patakaran",
      remove: "Alisin ang patakaran para sa {{segment}}",
      deleted: "(naburang segment)",
      emptyTitle: "Walang patakaran ng segment",
      emptyBody: "Magdagdag ng patakaran para mas maagang masagot ang mga customer sa isang segment.",
      noSegmentsTitle: "Wala pang segment",
      noSegmentsBody: "Gumawa muna ng segment sa Contacts, saka gamitin dito.",
      invalidSegment: "Pumili ng ibang segment para sa bawat patakaran.",
      save: "I-save ang mga patakaran",
      saved: "Na-save ang mga patakaran ng segment",
      saveFailed: "Hindi ma-save ang mga patakaran ng segment.",
      loadFailed: "Hindi ma-load ang mga segment.",
    },
    order: {
      title: "Live na pagkakasunod",
      intro: "Ang mga chat na naghihintay ng tao ngayon, ayon sa pagkakasunod na sasagutin sila.",
      position: "Blg.",
      chat: "Chat",
      chatLink: "Chat {{id}}",
      tier: "Tier",
      team: "Team",
      waited: "Naghihintay",
      score: "Puntos",
      stage: "Hawak ng",
      stageHost: "Nakatalagang host",
      stageTeam: "Sarili nitong team",
      stageGeneral: "Lahat",
      noTier: "Walang tier",
      safety: "Kinakailangang handover",
      alwaysFirst: "Laging una",
      emptyTitle: "Walang naghihintay",
      emptyBody: "Lalabas dito ang mga chat na naghihintay ng tao, nasa unahan ang may pinakamataas na ranggo.",
      loadFailed: "Hindi ma-load ang live na pagkakasunod.",
    },
    inbox: {
      sortedBy: "Nakaayos ayon sa priyoridad at tagal ng paghihintay",
      waiting: "Naghihintay {{time}}",
      scoreHint: "Puntos {{score}}: ang bigat ng tier dagdag ang aging",
      firstHint: "Laging unang sinasagot ang kinakailangang handover",
    },
  },
};
